﻿import Swiper from 'swiper';

const swiper = new Swiper('.swiper', {
    slidesPerView: 1.1,
    spaceBetween: 10,
    centeredSlides: true,
    breakpoints: {
        769: {
            slidesPerView: 2.1,
            spaceBetween: 20,
            centeredSlides: false,
        },
        1024: {
            slidesPerView: 4,
            spaceBetween: 24,
            centeredSlides: false,
        },
    }
});
